<script setup lang="ts">
import { NamedBindings, TranslationService, getContainer } from '@dandelion/core';
import Navbar from './components/NavbarComponent.vue';
import ConfirmExitDialogComponent from './components/Dialogs/ConfirmExitDialogComponent.vue';
const ts = getContainer().get(NamedBindings.TranslationService) as TranslationService;
</script>

<template>
  <KeepAlive>
    <Suspense> <Navbar></Navbar></Suspense
  ></KeepAlive>
  <RouterView v-slot="{ Component }">
    <template v-if="Component">
      <Suspense>
        <component :is="Component"></component>
        <template #fallback>
          <main>
            <div class="loading-spinner-container">
            <span class="generic-loading-msg loading-msg" v-html="`${ts.t('Loading')}...`"></span>
            <img src='/images/loading.gif' alt='Caricamento del caso' class='spinner'></div>
          </main>
        </template>
      </Suspense>
    </template>
  </RouterView>
      <ConfirmExitDialogComponent/>
</template>
